module.exports = {
  title: 'React Native Theme Canvas Animation 🎨',
  author: 'Enzo Manuel Mangano',
  date: '2023-02-01',
  slug: 'theme-canvas-animation',
  tags: ['skia'],
};
